import NotImplemented from '../../../../common/pages/NotImplemented'

const Categories = () => {
    return (
        <NotImplemented
            header={{ header: 'Google Analytics Event Categories' }}
            label={
                <>
                    <span className="text-primary">Analytics Categories</span>{' '}
                    has not been implemented yet!
                </>
            }
            description={
                <p>
                    I'm currently reviewing{' '}
                    <span className="text-success">Analytics</span> as Google
                    have changed it recently and will try to make it a little
                    bit broader!
                </p>
            }
        />
    )
}

export default Categories
